import { ADD_SALE } from "../../types/SaleType";
import axios from "axios";
import { toast } from "react-toastify";

const addPurchaseAciton = (data) => {
  return {
    type: ADD_SALE,
    payload: data,
  };
};

export const editSale = (editInvoiceId, valueData, documentType = 'sale') => {
  return async (dispatch) => {
    try {
      let endpoint;
      if (documentType === 'quotation') {
        endpoint = `quotation/${editInvoiceId}`;
      } else if (documentType === 'challan') {
        endpoint = `challan/${editInvoiceId}`;
      } else {
        endpoint = `sale-invoice/${editInvoiceId}`;
      }

      const { data } = await axios({
        method: "put",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: endpoint,
        data: {
          ...valueData,
        },
      });

      // Normalize response based on document type
      let updatedInvoice;
      if (documentType === 'quotation') {
        updatedInvoice = data.updatedQuotation;
      } else if (documentType === 'challan') {
        updatedInvoice = data.updatedChallan;
      } else {
        updatedInvoice = data.updatedInvoice;
      }

      const newData = {
        ...updatedInvoice,
        customer: data.customer || updatedInvoice.customer,
        document_type: documentType,
      };

      dispatch(addPurchaseAciton(newData));
      
      const docTypeName = documentType === 'quotation' ? 'Quotation' : documentType === 'challan' ? 'Challan' : 'Invoice';
      toast.success(`${docTypeName} Updated Successfully`);
      return {
        createdInvoiceId: updatedInvoice.id,
        message: "success",
      };
    } catch (error) {
      console.log(error.message);
      toast.error(`Error updating ${documentType}`);
      return {
        message: "error",
      };
    }
  };
};
